export const dairas = [
			{
				"id": 1,
				"wilaya_id": 1,
				"code": "1",
				"name": "Adrar",
				"name_ar": "أدرار"
			},
			{
				"id": 2,
				"wilaya_id": 1,
				"code": "2",
				"name": "Aoulef",
				"name_ar": "أولف"
			},
			{
				"id": 3,
				"wilaya_id": 1,
				"code": "3",
				"name": "Reggane",
				"name_ar": "رقان"
			},
			{
				"id": 4,
				"wilaya_id": 1,
				"code": "4",
				"name": "Zaouiat Kounta",
				"name_ar": "زاوية كنتة"
			},
			{
				"id": 5,
				"wilaya_id": 1,
				"code": "5",
				"name": "Fenoughil",
				"name_ar": "فنوغيل"
			},
			{
				"id": 6,
				"wilaya_id": 1,
				"code": "6",
				"name": "Tsabit",
				"name_ar": "تسابيت"
			},
			{
				"id": 7,
				"wilaya_id": 2,
				"code": "7",
				"name": "Chlef",
				"name_ar": "الشلف"
			},
			{
				"id": 8,
				"wilaya_id": 2,
				"code": "8",
				"name": "Oued Fodda",
				"name_ar": "وادي الفضة"
			},
			{
				"id": 9,
				"wilaya_id": 2,
				"code": "9",
				"name": "Boukadir",
				"name_ar": "بوقادير"
			},
			{
				"id": 10,
				"wilaya_id": 2,
				"code": "10",
				"name": "Ain Merane",
				"name_ar": "عين مران"
			},
			{
				"id": 11,
				"wilaya_id": 2,
				"code": "11",
				"name": "Tenes",
				"name_ar": "تنس"
			},
			{
				"id": 12,
				"wilaya_id": 2,
				"code": "12",
				"name": "Ouled Fares",
				"name_ar": "أولاد فارس"
			},
			{
				"id": 13,
				"wilaya_id": 2,
				"code": "13",
				"name": "El Karimia",
				"name_ar": "الكريمية"
			},
			{
				"id": 14,
				"wilaya_id": 2,
				"code": "14",
				"name": "Taougrit",
				"name_ar": "تاوقريت"
			},
			{
				"id": 15,
				"wilaya_id": 2,
				"code": "15",
				"name": "Zeboudja",
				"name_ar": "الزبوجة"
			},
			{
				"id": 16,
				"wilaya_id": 2,
				"code": "16",
				"name": "El Marsa",
				"name_ar": "المرسى"
			},
			{
				"id": 17,
				"wilaya_id": 2,
				"code": "17",
				"name": "Beni Haoua",
				"name_ar": "بني حواء"
			},
			{
				"id": 18,
				"wilaya_id": 2,
				"code": "18",
				"name": "Abou El Hassane",
				"name_ar": "أبو الحسن"
			},
			{
				"id": 19,
				"wilaya_id": 2,
				"code": "19",
				"name": "Ouled Ben Abdelkader",
				"name_ar": "أولاد بن عبد القادر"
			},
			{
				"id": 20,
				"wilaya_id": 3,
				"code": "20",
				"name": "Laghouat",
				"name_ar": "الأغواط"
			},
			{
				"id": 21,
				"wilaya_id": 3,
				"code": "21",
				"name": "Aflou",
				"name_ar": "أفلو"
			},
			{
				"id": 22,
				"wilaya_id": 3,
				"code": "22",
				"name": "Ksar El Hirane",
				"name_ar": "قصر الحيران"
			},
			{
				"id": 23,
				"wilaya_id": 3,
				"code": "23",
				"name": "Hassi R'mel",
				"name_ar": "حاسي الرمل"
			},
			{
				"id": 24,
				"wilaya_id": 3,
				"code": "24",
				"name": "Brida",
				"name_ar": "بريدة"
			},
			{
				"id": 25,
				"wilaya_id": 3,
				"code": "25",
				"name": "Ain Madhi",
				"name_ar": "عين ماضي"
			},
			{
				"id": 26,
				"wilaya_id": 3,
				"code": "26",
				"name": "Gueltat Sidi Saad",
				"name_ar": "قتلة سيدي سعيد"
			},
			{
				"id": 27,
				"wilaya_id": 3,
				"code": "27",
				"name": "Sidi Makhlouf",
				"name_ar": "سيدي مخلوف"
			},
			{
				"id": 28,
				"wilaya_id": 3,
				"code": "28",
				"name": "El Ghicha",
				"name_ar": "الغيشة"
			},
			{
				"id": 29,
				"wilaya_id": 3,
				"code": "29",
				"name": "Oued Morra",
				"name_ar": "وادي مرة"
			},
			{
				"id": 30,
				"wilaya_id": 4,
				"code": "30",
				"name": "Oum El Bouaghi",
				"name_ar": "أم البواقي"
			},
			{
				"id": 31,
				"wilaya_id": 4,
				"code": "31",
				"name": "Ain Beida",
				"name_ar": "عين البيضاء"
			},
			{
				"id": 32,
				"wilaya_id": 4,
				"code": "32",
				"name": "Ain M'lila",
				"name_ar": "عين مليلة"
			},
			{
				"id": 33,
				"wilaya_id": 4,
				"code": "33",
				"name": "Meskiana",
				"name_ar": "مسكيانة"
			},
			{
				"id": 34,
				"wilaya_id": 4,
				"code": "34",
				"name": "Ain Fekroun",
				"name_ar": "عين فكرون"
			},
			{
				"id": 35,
				"wilaya_id": 4,
				"code": "35",
				"name": "Ain Kercha",
				"name_ar": "عين كرشة"
			},
			{
				"id": 36,
				"wilaya_id": 4,
				"code": "36",
				"name": "Dhalaa",
				"name_ar": "الضلعة"
			},
			{
				"id": 37,
				"wilaya_id": 4,
				"code": "37",
				"name": "Souk Naamane",
				"name_ar": "سوق نعمان"
			},
			{
				"id": 38,
				"wilaya_id": 4,
				"code": "38",
				"name": "Sigus",
				"name_ar": "سيقوس"
			},
			{
				"id": 39,
				"wilaya_id": 4,
				"code": "39",
				"name": "F'kirina",
				"name_ar": "فكيرينة"
			},
			{
				"id": 40,
				"wilaya_id": 4,
				"code": "40",
				"name": "Ksar Sbahi",
				"name_ar": "قصر الصباحي"
			},
			{
				"id": 41,
				"wilaya_id": 4,
				"code": "41",
				"name": "Ain Babouche",
				"name_ar": "عين ببوش"
			},
			{
				"id": 42,
				"wilaya_id": 5,
				"code": "42",
				"name": "Batna",
				"name_ar": "باتنة"
			},
			{
				"id": 43,
				"wilaya_id": 5,
				"code": "43",
				"name": "Barika",
				"name_ar": "بريكة"
			},
			{
				"id": 44,
				"wilaya_id": 5,
				"code": "44",
				"name": "Ain Touta",
				"name_ar": "عين التوتة"
			},
			{
				"id": 45,
				"wilaya_id": 5,
				"code": "45",
				"name": "N'gaous",
				"name_ar": "نقاوس"
			},
			{
				"id": 46,
				"wilaya_id": 5,
				"code": "46",
				"name": "Arris",
				"name_ar": "أريس"
			},
			{
				"id": 47,
				"wilaya_id": 5,
				"code": "47",
				"name": "Ras El Aioun",
				"name_ar": "رأس العيون"
			},
			{
				"id": 48,
				"wilaya_id": 5,
				"code": "48",
				"name": "Tazoult",
				"name_ar": "تازولت"
			},
			{
				"id": 49,
				"wilaya_id": 5,
				"code": "49",
				"name": "Menaa",
				"name_ar": "منعة"
			},
			{
				"id": 50,
				"wilaya_id": 5,
				"code": "50",
				"name": "Merouana",
				"name_ar": "مروانة"
			},
			{
				"id": 51,
				"wilaya_id": 5,
				"code": "51",
				"name": "El Madher",
				"name_ar": "المعذر"
			},
			{
				"id": 52,
				"wilaya_id": 5,
				"code": "52",
				"name": "Tkout",
				"name_ar": "تكوت"
			},
			{
				"id": 53,
				"wilaya_id": 5,
				"code": "53",
				"name": "Timgad",
				"name_ar": "تيمقاد"
			},
			{
				"id": 54,
				"wilaya_id": 5,
				"code": "54",
				"name": "Seriana",
				"name_ar": "سريانة"
			},
			{
				"id": 55,
				"wilaya_id": 5,
				"code": "55",
				"name": "Ichemoul",
				"name_ar": "إشمول"
			},
			{
				"id": 56,
				"wilaya_id": 5,
				"code": "56",
				"name": "Seggana",
				"name_ar": "سقانة"
			},
			{
				"id": 57,
				"wilaya_id": 5,
				"code": "57",
				"name": "Ain Djasser",
				"name_ar": "عين جاسر"
			},
			{
				"id": 58,
				"wilaya_id": 5,
				"code": "58",
				"name": "Theniet El Abed",
				"name_ar": "ثنية العابد"
			},
			{
				"id": 59,
				"wilaya_id": 5,
				"code": "59",
				"name": "Chemora",
				"name_ar": "الشمرة"
			},
			{
				"id": 60,
				"wilaya_id": 5,
				"code": "60",
				"name": "Bouzina",
				"name_ar": "بوزينة"
			},
			{
				"id": 61,
				"wilaya_id": 5,
				"code": "61",
				"name": "Djezzar",
				"name_ar": "الجزار"
			},
			{
				"id": 62,
				"wilaya_id": 5,
				"code": "62",
				"name": "Ouled Si Slimane",
				"name_ar": "أولاد سي سليمان"
			},
			{
				"id": 63,
				"wilaya_id": 6,
				"code": "63",
				"name": "Bejaia",
				"name_ar": "بجاية"
			},
			{
				"id": 64,
				"wilaya_id": 6,
				"code": "64",
				"name": "Akbou",
				"name_ar": "أقبو"
			},
			{
				"id": 65,
				"wilaya_id": 6,
				"code": "65",
				"name": "El Kseur",
				"name_ar": "القصر"
			},
			{
				"id": 66,
				"wilaya_id": 6,
				"code": "66",
				"name": "Kherrata",
				"name_ar": "خراطة"
			},
			{
				"id": 67,
				"wilaya_id": 6,
				"code": "67",
				"name": "Sidi Aich",
				"name_ar": "سيدي عيش"
			},
			{
				"id": 68,
				"wilaya_id": 6,
				"code": "68",
				"name": "Tazmalt",
				"name_ar": "تازملت"
			},
			{
				"id": 69,
				"wilaya_id": 6,
				"code": "69",
				"name": "Aokas",
				"name_ar": "أوقاس"
			},
			{
				"id": 70,
				"wilaya_id": 6,
				"code": "70",
				"name": "Amizour",
				"name_ar": "أميزور"
			},
			{
				"id": 71,
				"wilaya_id": 6,
				"code": "71",
				"name": "Barbacha",
				"name_ar": "برباشة"
			},
			{
				"id": 72,
				"wilaya_id": 6,
				"code": "72",
				"name": "Ifri Ouzellaguene",
				"name_ar": "إفري أوزلاقن"
			},
			{
				"id": 73,
				"wilaya_id": 6,
				"code": "73",
				"name": "Seddouk",
				"name_ar": "صدوق"
			},
			{
				"id": 74,
				"wilaya_id": 6,
				"code": "74",
				"name": "Souk El Tenine",
				"name_ar": "سوق الإثنين"
			},
			{
				"id": 75,
				"wilaya_id": 6,
				"code": "75",
				"name": "Ighil Ali",
				"name_ar": "إغيل علي"
			},
			{
				"id": 76,
				"wilaya_id": 6,
				"code": "76",
				"name": "Darguina",
				"name_ar": "درقينة"
			},
			{
				"id": 77,
				"wilaya_id": 6,
				"code": "77",
				"name": "Timezrit",
				"name_ar": "تيمزريت"
			},
			{
				"id": 78,
				"wilaya_id": 6,
				"code": "78",
				"name": "Adekar",
				"name_ar": "أدكار"
			},
			{
				"id": 79,
				"wilaya_id": 6,
				"code": "79",
				"name": "Chemini",
				"name_ar": "شميني"
			},
			{
				"id": 80,
				"wilaya_id": 6,
				"code": "80",
				"name": "Tichy",
				"name_ar": "تيشي"
			},
			{
				"id": 81,
				"wilaya_id": 6,
				"code": "81",
				"name": "Beni Maouche",
				"name_ar": "بني معوش"
			},
			{
				"id": 82,
				"wilaya_id": 7,
				"code": "82",
				"name": "Biskra",
				"name_ar": "بسكرة"
			},
			{
				"id": 83,
				"wilaya_id": 7,
				"code": "83",
				"name": "Tolga",
				"name_ar": "طولقة"
			},
			{
				"id": 84,
				"wilaya_id": 7,
				"code": "84",
				"name": "Sidi Okba",
				"name_ar": "سيدي عقبة"
			},
			{
				"id": 85,
				"wilaya_id": 7,
				"code": "85",
				"name": "El Kantara",
				"name_ar": "القنطرة"
			},
			{
				"id": 86,
				"wilaya_id": 7,
				"code": "86",
				"name": "Mechouneche",
				"name_ar": "مشونش"
			},
			{
				"id": 87,
				"wilaya_id": 7,
				"code": "87",
				"name": "Ourlal",
				"name_ar": "أورلال"
			},
			{
				"id": 88,
				"wilaya_id": 7,
				"code": "88",
				"name": "Zeribet El Oued",
				"name_ar": "زريبة الوادي"
			},
			{
				"id": 89,
				"wilaya_id": 7,
				"code": "89",
				"name": "Djemorah",
				"name_ar": "جمورة"
			},
			{
				"id": 90,
				"wilaya_id": 7,
				"code": "90",
				"name": "Foughala",
				"name_ar": "فوغالة"
			},
			{
				"id": 91,
				"wilaya_id": 7,
				"code": "91",
				"name": "El Outaya",
				"name_ar": "الوطاية"
			},
			{
				"id": 92,
				"wilaya_id": 8,
				"code": "92",
				"name": "Bechar",
				"name_ar": "بشار"
			},
			{
				"id": 93,
				"wilaya_id": 8,
				"code": "93",
				"name": "Abadla",
				"name_ar": "العبادلة"
			},
			{
				"id": 94,
				"wilaya_id": 8,
				"code": "94",
				"name": "Beni Ounif",
				"name_ar": "بني ونيف"
			},
			{
				"id": 95,
				"wilaya_id": 8,
				"code": "95",
				"name": "Kenadsa",
				"name_ar": "القنادسة"
			},
			{
				"id": 96,
				"wilaya_id": 8,
				"code": "96",
				"name": "Lahmar",
				"name_ar": "لحمر"
			},
			{
				"id": 97,
				"wilaya_id": 8,
				"code": "97",
				"name": "Tabelbala",
				"name_ar": "تبلبالة"
			},
			{
				"id": 98,
				"wilaya_id": 8,
				"code": "98",
				"name": "Taghit",
				"name_ar": "تاغيت"
			},
			{
				"id": 99,
				"wilaya_id": 9,
				"code": "99",
				"name": "Blida",
				"name_ar": "البليدة"
			},
			{
				"id": 100,
				"wilaya_id": 9,
				"code": "100",
				"name": "Boufarik",
				"name_ar": "بوفاريك"
			},
			{
				"id": 101,
				"wilaya_id": 9,
				"code": "101",
				"name": "Larbaa",
				"name_ar": "الأربعاء"
			},
			{
				"id": 102,
				"wilaya_id": 9,
				"code": "102",
				"name": "Ouled Yaich",
				"name_ar": "أولاد يعيش"
			},
			{
				"id": 103,
				"wilaya_id": 9,
				"code": "103",
				"name": "Bougara",
				"name_ar": "بوقرة"
			},
			{
				"id": 104,
				"wilaya_id": 9,
				"code": "104",
				"name": "Bouinan",
				"name_ar": "بوعينان"
			},
			{
				"id": 105,
				"wilaya_id": 9,
				"code": "105",
				"name": "Mouzaia",
				"name_ar": "موزاية"
			},
			{
				"id": 106,
				"wilaya_id": 9,
				"code": "106",
				"name": "El Affroun",
				"name_ar": "العفرون"
			},
			{
				"id": 107,
				"wilaya_id": 9,
				"code": "107",
				"name": "Meftah",
				"name_ar": "مفتاح"
			},
			{
				"id": 108,
				"wilaya_id": 9,
				"code": "108",
				"name": "Oued El Alleug",
				"name_ar": "وادي العلايق"
			},
			{
				"id": 109,
				"wilaya_id": 10,
				"code": "109",
				"name": "Bouira",
				"name_ar": "البويرة"
			},
			{
				"id": 110,
				"wilaya_id": 10,
				"code": "110",
				"name": "Lakhdaria",
				"name_ar": "الأخضرية"
			},
			{
				"id": 111,
				"wilaya_id": 10,
				"code": "111",
				"name": "M'chedallah",
				"name_ar": "مشد الله"
			},
			{
				"id": 112,
				"wilaya_id": 10,
				"code": "112",
				"name": "Sour El Ghozlane",
				"name_ar": "سور الغزلان"
			},
			{
				"id": 113,
				"wilaya_id": 10,
				"code": "113",
				"name": "Ain Bessem",
				"name_ar": "عين بسام"
			},
			{
				"id": 114,
				"wilaya_id": 10,
				"code": "114",
				"name": "Kadiria",
				"name_ar": "القادرية"
			},
			{
				"id": 115,
				"wilaya_id": 10,
				"code": "115",
				"name": "Bechloul",
				"name_ar": "بشلول"
			},
			{
				"id": 116,
				"wilaya_id": 10,
				"code": "116",
				"name": "Bir Ghbalou",
				"name_ar": "بئر غبالو"
			},
			{
				"id": 117,
				"wilaya_id": 10,
				"code": "117",
				"name": "Bordj Okhriss",
				"name_ar": "برج أوخريص"
			},
			{
				"id": 118,
				"wilaya_id": 10,
				"code": "118",
				"name": "El Hachimia",
				"name_ar": "الهاشمية"
			},
			{
				"id": 119,
				"wilaya_id": 10,
				"code": "119",
				"name": "Haizer",
				"name_ar": "الحيزر"
			},
			{
				"id": 120,
				"wilaya_id": 10,
				"code": "120",
				"name": "Souk El Khemis",
				"name_ar": "سوق الخميس"
			},
			{
				"id": 121,
				"wilaya_id": 11,
				"code": "121",
				"name": "Tamanrasset",
				"name_ar": "تمنراست"
			},
			{
				"id": 122,
				"wilaya_id": 11,
				"code": "122",
				"name": "Silet",
				"name_ar": "سيلت"
			},
			{
				"id": 123,
				"wilaya_id": 11,
				"code": "123",
				"name": "Tazrouk",
				"name_ar": "تاظروك"
			},
			{
				"id": 124,
				"wilaya_id": 12,
				"code": "124",
				"name": "Tebessa",
				"name_ar": "تبسة"
			},
			{
				"id": 125,
				"wilaya_id": 12,
				"code": "125",
				"name": "Bir El Ater",
				"name_ar": "بئر العاتر"
			},
			{
				"id": 126,
				"wilaya_id": 12,
				"code": "126",
				"name": "Cheria",
				"name_ar": "الشريعة"
			},
			{
				"id": 127,
				"wilaya_id": 12,
				"code": "127",
				"name": "Ouenza",
				"name_ar": "الونزة"
			},
			{
				"id": 128,
				"wilaya_id": 12,
				"code": "128",
				"name": "El Aouinet",
				"name_ar": "العوينات"
			},
			{
				"id": 129,
				"wilaya_id": 12,
				"code": "129",
				"name": "El Kouif",
				"name_ar": "الكويف"
			},
			{
				"id": 130,
				"wilaya_id": 12,
				"code": "130",
				"name": "Bir Mokadem",
				"name_ar": "بئر مقدم"
			},
			{
				"id": 131,
				"wilaya_id": 12,
				"code": "131",
				"name": "El Malabiod",
				"name_ar": "الماء الابيض"
			},
			{
				"id": 132,
				"wilaya_id": 12,
				"code": "132",
				"name": "El Ogla",
				"name_ar": "العقلة"
			},
			{
				"id": 133,
				"wilaya_id": 12,
				"code": "133",
				"name": "Morsott",
				"name_ar": "مرسط"
			},
			{
				"id": 134,
				"wilaya_id": 12,
				"code": "134",
				"name": "Negrine",
				"name_ar": "نقرين"
			},
			{
				"id": 135,
				"wilaya_id": 12,
				"code": "135",
				"name": "Oum Ali",
				"name_ar": "أم علي"
			},
			{
				"id": 136,
				"wilaya_id": 13,
				"code": "136",
				"name": "Tlemcen",
				"name_ar": "تلمسان"
			},
			{
				"id": 137,
				"wilaya_id": 13,
				"code": "137",
				"name": "Maghnia",
				"name_ar": "مغنية"
			},
			{
				"id": 138,
				"wilaya_id": 13,
				"code": "138",
				"name": "Ghazaouet",
				"name_ar": "الغزوات"
			},
			{
				"id": 139,
				"wilaya_id": 13,
				"code": "139",
				"name": "Nedroma",
				"name_ar": "ندرومة"
			},
			{
				"id": 140,
				"wilaya_id": 13,
				"code": "140",
				"name": "Remchi",
				"name_ar": "الرمشي"
			},
			{
				"id": 141,
				"wilaya_id": 13,
				"code": "141",
				"name": "Sebdou",
				"name_ar": "سبدو"
			},
			{
				"id": 142,
				"wilaya_id": 13,
				"code": "142",
				"name": "Bensekrane",
				"name_ar": "بن سكران"
			},
			{
				"id": 143,
				"wilaya_id": 13,
				"code": "143",
				"name": "Hennaya",
				"name_ar": "الحناية"
			},
			{
				"id": 144,
				"wilaya_id": 13,
				"code": "144",
				"name": "Ouled Mimoun",
				"name_ar": "أولاد ميمون"
			},
			{
				"id": 145,
				"wilaya_id": 13,
				"code": "145",
				"name": "Sabra",
				"name_ar": "صبرة"
			},
			{
				"id": 146,
				"wilaya_id": 13,
				"code": "146",
				"name": "Ain Tellout",
				"name_ar": "عين تالوت"
			},
			{
				"id": 147,
				"wilaya_id": 13,
				"code": "147",
				"name": "Bab El Assa",
				"name_ar": "باب العسة"
			},
			{
				"id": 148,
				"wilaya_id": 13,
				"code": "148",
				"name": "Honnaine",
				"name_ar": "هنين"
			},
			{
				"id": 149,
				"wilaya_id": 13,
				"code": "149",
				"name": "Marsa Ben Mehdi",
				"name_ar": "مرسى بن مهيدي"
			},
			{
				"id": 150,
				"wilaya_id": 13,
				"code": "150",
				"name": "Chetouane",
				"name_ar": "شتوان"
			},
			{
				"id": 151,
				"wilaya_id": 13,
				"code": "151",
				"name": "Mansourah",
				"name_ar": "منصورة"
			},
			{
				"id": 152,
				"wilaya_id": 13,
				"code": "152",
				"name": "Fellaoucene",
				"name_ar": "فلاوسن"
			},
			{
				"id": 153,
				"wilaya_id": 13,
				"code": "153",
				"name": "Sidi Djillali",
				"name_ar": "سيدي الجيلالي"
			},
			{
				"id": 154,
				"wilaya_id": 13,
				"code": "154",
				"name": "Beni Snous",
				"name_ar": "بني سنوس"
			},
			{
				"id": 155,
				"wilaya_id": 13,
				"code": "155",
				"name": "Beni Boussaid",
				"name_ar": "بني بوسعيد"
			},
			{
				"id": 156,
				"wilaya_id": 14,
				"code": "156",
				"name": "Tiaret",
				"name_ar": "تيارت"
			},
			{
				"id": 157,
				"wilaya_id": 14,
				"code": "157",
				"name": "Frenda",
				"name_ar": "فرندة"
			},
			{
				"id": 158,
				"wilaya_id": 14,
				"code": "158",
				"name": "Ksar Chellala",
				"name_ar": "قصر الشلالة"
			},
			{
				"id": 159,
				"wilaya_id": 14,
				"code": "159",
				"name": "Sougueur",
				"name_ar": "السوقر"
			},
			{
				"id": 160,
				"wilaya_id": 14,
				"code": "160",
				"name": "Mahdia",
				"name_ar": "مهدية"
			},
			{
				"id": 161,
				"wilaya_id": 14,
				"code": "161",
				"name": "Rahouia",
				"name_ar": "رحوية"
			},
			{
				"id": 162,
				"wilaya_id": 14,
				"code": "162",
				"name": "Ain Deheb",
				"name_ar": "عين الذهب"
			},
			{
				"id": 163,
				"wilaya_id": 14,
				"code": "163",
				"name": "Ain Kermes",
				"name_ar": "عين كرمس"
			},
			{
				"id": 164,
				"wilaya_id": 14,
				"code": "164",
				"name": "Dahmouni",
				"name_ar": "دحموني"
			},
			{
				"id": 165,
				"wilaya_id": 14,
				"code": "165",
				"name": "Mechraa Sfa",
				"name_ar": "مشرع الصفا"
			},
			{
				"id": 166,
				"wilaya_id": 14,
				"code": "166",
				"name": "Oued Lili",
				"name_ar": "وادي ليلي"
			},
			{
				"id": 167,
				"wilaya_id": 14,
				"code": "167",
				"name": "Hamadia",
				"name_ar": "حمادية"
			},
			{
				"id": 168,
				"wilaya_id": 14,
				"code": "168",
				"name": "Medroussa",
				"name_ar": "مدروسة"
			},
			{
				"id": 169,
				"wilaya_id": 14,
				"code": "169",
				"name": "Meghila",
				"name_ar": "مغيلة"
			},
			{
				"id": 170,
				"wilaya_id": 15,
				"code": "170",
				"name": "Tizi Ouzou",
				"name_ar": "تيزي وزو"
			},
			{
				"id": 171,
				"wilaya_id": 15,
				"code": "171",
				"name": "Azazga",
				"name_ar": "عزازقة"
			},
			{
				"id": 172,
				"wilaya_id": 15,
				"code": "172",
				"name": "Ain El Hammam",
				"name_ar": "عين الحمام"
			},
			{
				"id": 173,
				"wilaya_id": 15,
				"code": "173",
				"name": "Boghni",
				"name_ar": "بوغني"
			},
			{
				"id": 174,
				"wilaya_id": 15,
				"code": "174",
				"name": "Draa Ben Khedda",
				"name_ar": "ذراع بن خدة"
			},
			{
				"id": 175,
				"wilaya_id": 15,
				"code": "175",
				"name": "Draa El Mizan",
				"name_ar": "ذراع الميزان"
			},
			{
				"id": 176,
				"wilaya_id": 15,
				"code": "176",
				"name": "Larbaa Nath Iraten",
				"name_ar": "الأربعاء ناث إيراثن"
			},
			{
				"id": 177,
				"wilaya_id": 15,
				"code": "177",
				"name": "Bouzeguene",
				"name_ar": "بوزقن"
			},
			{
				"id": 178,
				"wilaya_id": 15,
				"code": "178",
				"name": "Azeffoun",
				"name_ar": "أزفون"
			},
			{
				"id": 179,
				"wilaya_id": 15,
				"code": "179",
				"name": "Beni Douala",
				"name_ar": "بني دوالة"
			},
			{
				"id": 180,
				"wilaya_id": 15,
				"code": "180",
				"name": "Iferhounene",
				"name_ar": "إفرحونان"
			},
			{
				"id": 181,
				"wilaya_id": 15,
				"code": "181",
				"name": "Mekla",
				"name_ar": "مقلع"
			},
			{
				"id": 182,
				"wilaya_id": 15,
				"code": "182",
				"name": "Ouacif",
				"name_ar": "واسيف"
			},
			{
				"id": 183,
				"wilaya_id": 15,
				"code": "183",
				"name": "Ouadhias",
				"name_ar": "واضية"
			},
			{
				"id": 184,
				"wilaya_id": 15,
				"code": "184",
				"name": "Maatkas",
				"name_ar": "معاتقة"
			},
			{
				"id": 185,
				"wilaya_id": 15,
				"code": "185",
				"name": "Tigzirt",
				"name_ar": "تيقزيرت"
			},
			{
				"id": 186,
				"wilaya_id": 15,
				"code": "186",
				"name": "Tizi-Ghenif",
				"name_ar": "تيزي غنيف"
			},
			{
				"id": 187,
				"wilaya_id": 15,
				"code": "187",
				"name": "Benni Yenni",
				"name_ar": "بني يني"
			},
			{
				"id": 188,
				"wilaya_id": 15,
				"code": "188",
				"name": "Makouda",
				"name_ar": "ماكودة"
			},
			{
				"id": 189,
				"wilaya_id": 15,
				"code": "189",
				"name": "Ouaguenoun",
				"name_ar": "واقنون"
			},
			{
				"id": 190,
				"wilaya_id": 15,
				"code": "190",
				"name": "Tizi Rached",
				"name_ar": "تيزي راشد"
			},
			{
				"id": 191,
				"wilaya_id": 16,
				"code": "191",
				"name": "Sidi M'hamed",
				"name_ar": "سيدي امحمد"
			},
			{
				"id": 192,
				"wilaya_id": 16,
				"code": "192",
				"name": "Bab El Oued",
				"name_ar": "باب الوادي"
			},
			{
				"id": 193,
				"wilaya_id": 16,
				"code": "193",
				"name": "Bouzareah",
				"name_ar": "بوزريعة"
			},
			{
				"id": 194,
				"wilaya_id": 16,
				"code": "194",
				"name": "Hussein Dey",
				"name_ar": "حسين داي"
			},
			{
				"id": 195,
				"wilaya_id": 16,
				"code": "195",
				"name": "Bir Mourad Rais",
				"name_ar": "بئر مراد رايس"
			},
			{
				"id": 196,
				"wilaya_id": 16,
				"code": "196",
				"name": "Cheraga",
				"name_ar": "الشراقة"
			},
			{
				"id": 197,
				"wilaya_id": 16,
				"code": "197",
				"name": "Birtouta",
				"name_ar": "بئر توتة"
			},
			{
				"id": 198,
				"wilaya_id": 16,
				"code": "198",
				"name": "Draria",
				"name_ar": "الدرارية"
			},
			{
				"id": 199,
				"wilaya_id": 16,
				"code": "199",
				"name": "Zeralda",
				"name_ar": "زرالدة"
			},
			{
				"id": 200,
				"wilaya_id": 16,
				"code": "200",
				"name": "El Harrach",
				"name_ar": "الحراش"
			},
			{
				"id": 201,
				"wilaya_id": 16,
				"code": "201",
				"name": "Rouiba",
				"name_ar": "الرويبة"
			},
			{
				"id": 202,
				"wilaya_id": 16,
				"code": "202",
				"name": "Dar El Beida",
				"name_ar": "الدار البيضاء"
			},
			{
				"id": 203,
				"wilaya_id": 16,
				"code": "203",
				"name": "Baraki",
				"name_ar": "براقي"
			},
			{
				"id": 204,
				"wilaya_id": 17,
				"code": "204",
				"name": "Djelfa",
				"name_ar": "الجلفة"
			},
			{
				"id": 205,
				"wilaya_id": 17,
				"code": "205",
				"name": "Ain Oussera",
				"name_ar": "عين وسارة"
			},
			{
				"id": 206,
				"wilaya_id": 17,
				"code": "206",
				"name": "Hassi Bahbah",
				"name_ar": "حاسي بحبح"
			},
			{
				"id": 207,
				"wilaya_id": 17,
				"code": "207",
				"name": "Messaad",
				"name_ar": "مسعد"
			},
			{
				"id": 208,
				"wilaya_id": 17,
				"code": "208",
				"name": "Dar Chioukh",
				"name_ar": "دار الشيوخ"
			},
			{
				"id": 209,
				"wilaya_id": 17,
				"code": "209",
				"name": "Ain El Ibel",
				"name_ar": "عين الإبل"
			},
			{
				"id": 210,
				"wilaya_id": 17,
				"code": "210",
				"name": "Birine",
				"name_ar": "بيرين"
			},
			{
				"id": 211,
				"wilaya_id": 17,
				"code": "211",
				"name": "Charef",
				"name_ar": "الشارف"
			},
			{
				"id": 212,
				"wilaya_id": 17,
				"code": "212",
				"name": "El Idrissia",
				"name_ar": "الادريسية"
			},
			{
				"id": 213,
				"wilaya_id": 17,
				"code": "213",
				"name": "Faidh El Botma",
				"name_ar": "فيض البطمة"
			},
			{
				"id": 214,
				"wilaya_id": 17,
				"code": "214",
				"name": "Had Sahary",
				"name_ar": "حد الصحاري"
			},
			{
				"id": 215,
				"wilaya_id": 17,
				"code": "215",
				"name": "Sidi Laadjel",
				"name_ar": "سيدي لعجال"
			},
			{
				"id": 216,
				"wilaya_id": 18,
				"code": "216",
				"name": "Jijel",
				"name_ar": "جيجل"
			},
			{
				"id": 217,
				"wilaya_id": 18,
				"code": "217",
				"name": "El Milia",
				"name_ar": "الميلية"
			},
			{
				"id": 218,
				"wilaya_id": 18,
				"code": "218",
				"name": "Taher",
				"name_ar": "الطاهير"
			},
			{
				"id": 219,
				"wilaya_id": 18,
				"code": "219",
				"name": "Chekfa",
				"name_ar": "الشقفة"
			},
			{
				"id": 220,
				"wilaya_id": 18,
				"code": "220",
				"name": "El Ancer",
				"name_ar": "العنصر"
			},
			{
				"id": 221,
				"wilaya_id": 18,
				"code": "221",
				"name": "El Aouana",
				"name_ar": "العوانة"
			},
			{
				"id": 222,
				"wilaya_id": 18,
				"code": "222",
				"name": "Texenna",
				"name_ar": "تاكسنة"
			},
			{
				"id": 223,
				"wilaya_id": 18,
				"code": "223",
				"name": "Ziamah Mansouriah",
				"name_ar": "زيامة منصورية"
			},
			{
				"id": 224,
				"wilaya_id": 18,
				"code": "224",
				"name": "Settara",
				"name_ar": "السطارة"
			},
			{
				"id": 225,
				"wilaya_id": 18,
				"code": "225",
				"name": "Sidi Marouf",
				"name_ar": "سيدي معروف"
			},
			{
				"id": 226,
				"wilaya_id": 18,
				"code": "226",
				"name": "Djimla",
				"name_ar": "جيملة"
			},
			{
				"id": 227,
				"wilaya_id": 19,
				"code": "227",
				"name": "Setif",
				"name_ar": "سطيف"
			},
			{
				"id": 228,
				"wilaya_id": 19,
				"code": "228",
				"name": "El Eulma",
				"name_ar": "العلمة"
			},
			{
				"id": 229,
				"wilaya_id": 19,
				"code": "229",
				"name": "Ain Oulmene",
				"name_ar": "عين ولمان"
			},
			{
				"id": 230,
				"wilaya_id": 19,
				"code": "230",
				"name": "Bougaa",
				"name_ar": "بوقاعة"
			},
			{
				"id": 231,
				"wilaya_id": 19,
				"code": "231",
				"name": "Ain Azel",
				"name_ar": "عين أزال"
			},
			{
				"id": 232,
				"wilaya_id": 19,
				"code": "232",
				"name": "Ain El Kebira",
				"name_ar": "عين الكبيرة"
			},
			{
				"id": 233,
				"wilaya_id": 19,
				"code": "233",
				"name": "Amoucha",
				"name_ar": "عموشة"
			},
			{
				"id": 234,
				"wilaya_id": 19,
				"code": "234",
				"name": "Beni Aziz",
				"name_ar": "بني عزيز"
			},
			{
				"id": 235,
				"wilaya_id": 19,
				"code": "235",
				"name": "Beni Ourtilane",
				"name_ar": "بني ورتيلان"
			},
			{
				"id": 236,
				"wilaya_id": 19,
				"code": "236",
				"name": "Bouandas",
				"name_ar": "بوعنداس"
			},
			{
				"id": 237,
				"wilaya_id": 19,
				"code": "237",
				"name": "Salah Bey",
				"name_ar": "صالح باي"
			},
			{
				"id": 238,
				"wilaya_id": 19,
				"code": "238",
				"name": "Ain Arnat",
				"name_ar": "عين أرنات"
			},
			{
				"id": 239,
				"wilaya_id": 19,
				"code": "239",
				"name": "Babor",
				"name_ar": "بابور"
			},
			{
				"id": 240,
				"wilaya_id": 19,
				"code": "240",
				"name": "Bir El Arch",
				"name_ar": "بئر العرش"
			},
			{
				"id": 241,
				"wilaya_id": 19,
				"code": "241",
				"name": "Djemila",
				"name_ar": "جميلة"
			},
			{
				"id": 242,
				"wilaya_id": 19,
				"code": "242",
				"name": "Guenzet",
				"name_ar": "قنزات"
			},
			{
				"id": 243,
				"wilaya_id": 19,
				"code": "243",
				"name": "Guidjel",
				"name_ar": "قجال"
			},
			{
				"id": 244,
				"wilaya_id": 19,
				"code": "244",
				"name": "Maoklane",
				"name_ar": "ماوكلان"
			},
			{
				"id": 245,
				"wilaya_id": 19,
				"code": "245",
				"name": "Hammam Guergour",
				"name_ar": "حمام قرقور"
			},
			{
				"id": 246,
				"wilaya_id": 19,
				"code": "246",
				"name": "Hammam Sokhna",
				"name_ar": "حمام السخنة"
			},
			{
				"id": 247,
				"wilaya_id": 20,
				"code": "247",
				"name": "Saida",
				"name_ar": "سعيدة"
			},
			{
				"id": 248,
				"wilaya_id": 20,
				"code": "248",
				"name": "Ain El Hadjar",
				"name_ar": "عين الحجر"
			},
			{
				"id": 249,
				"wilaya_id": 20,
				"code": "249",
				"name": "Ouled Brahim",
				"name_ar": "أولاد ابراهيم"
			},
			{
				"id": 250,
				"wilaya_id": 20,
				"code": "250",
				"name": "El Hassasna",
				"name_ar": "الحساسنة"
			},
			{
				"id": 251,
				"wilaya_id": 20,
				"code": "251",
				"name": "Sidi Boubekeur",
				"name_ar": "سيدي بوبكر"
			},
			{
				"id": 252,
				"wilaya_id": 20,
				"code": "252",
				"name": "Youb",
				"name_ar": "يوب"
			},
			{
				"id": 253,
				"wilaya_id": 21,
				"code": "253",
				"name": "Skikda",
				"name_ar": "سكيكدة"
			},
			{
				"id": 254,
				"wilaya_id": 21,
				"code": "254",
				"name": "Azzaba",
				"name_ar": "عزابة"
			},
			{
				"id": 255,
				"wilaya_id": 21,
				"code": "255",
				"name": "Collo",
				"name_ar": "القل"
			},
			{
				"id": 256,
				"wilaya_id": 21,
				"code": "256",
				"name": "El Harrouch",
				"name_ar": "الحروش"
			},
			{
				"id": 257,
				"wilaya_id": 21,
				"code": "257",
				"name": "Ramdane Djamel",
				"name_ar": "رمضان جمال"
			},
			{
				"id": 258,
				"wilaya_id": 21,
				"code": "258",
				"name": "Tamalous",
				"name_ar": "تمالوس"
			},
			{
				"id": 259,
				"wilaya_id": 21,
				"code": "259",
				"name": "Ain Kechra",
				"name_ar": "عين قشرة"
			},
			{
				"id": 260,
				"wilaya_id": 21,
				"code": "260",
				"name": "Ben Azzouz",
				"name_ar": "بن عزوز"
			},
			{
				"id": 261,
				"wilaya_id": 21,
				"code": "261",
				"name": "Sidi Mezghiche",
				"name_ar": "سيدي مزغيش"
			},
			{
				"id": 262,
				"wilaya_id": 21,
				"code": "262",
				"name": "Ouled Attia",
				"name_ar": "أولاد عطية"
			},
			{
				"id": 263,
				"wilaya_id": 21,
				"code": "263",
				"name": "El Hadaiek",
				"name_ar": "الحدائق"
			},
			{
				"id": 264,
				"wilaya_id": 21,
				"code": "264",
				"name": "Oum Toub",
				"name_ar": "أم الطوب"
			},
			{
				"id": 265,
				"wilaya_id": 21,
				"code": "265",
				"name": "Zitouna",
				"name_ar": "الزيتونة"
			},
			{
				"id": 266,
				"wilaya_id": 22,
				"code": "266",
				"name": "Sidi Bel Abbes",
				"name_ar": "سيدي بلعباس"
			},
			{
				"id": 267,
				"wilaya_id": 22,
				"code": "267",
				"name": "Sfisef",
				"name_ar": "سفيزف"
			},
			{
				"id": 268,
				"wilaya_id": 22,
				"code": "268",
				"name": "Ben Badis",
				"name_ar": "بن باديس"
			},
			{
				"id": 269,
				"wilaya_id": 22,
				"code": "269",
				"name": "Telagh",
				"name_ar": "تلاغ"
			},
			{
				"id": 270,
				"wilaya_id": 22,
				"code": "270",
				"name": "Sidi Ali Ben Youb",
				"name_ar": "سيدي علي بن يوب"
			},
			{
				"id": 271,
				"wilaya_id": 22,
				"code": "271",
				"name": "Marhoum",
				"name_ar": "مرحوم"
			},
			{
				"id": 272,
				"wilaya_id": 22,
				"code": "272",
				"name": "Merine",
				"name_ar": "مرين"
			},
			{
				"id": 273,
				"wilaya_id": 22,
				"code": "273",
				"name": "Mostefa  Ben Brahim",
				"name_ar": "مصطفى بن ابراهيم"
			},
			{
				"id": 274,
				"wilaya_id": 22,
				"code": "274",
				"name": "Sidi Ali Boussidi",
				"name_ar": "سيدي علي بوسيدي"
			},
			{
				"id": 275,
				"wilaya_id": 22,
				"code": "275",
				"name": "Ain El Berd",
				"name_ar": "عين البرد"
			},
			{
				"id": 276,
				"wilaya_id": 22,
				"code": "276",
				"name": "Sidi Lahcene",
				"name_ar": "سيدي لحسن"
			},
			{
				"id": 277,
				"wilaya_id": 22,
				"code": "277",
				"name": "Tenira",
				"name_ar": "تنيرة"
			},
			{
				"id": 278,
				"wilaya_id": 22,
				"code": "278",
				"name": "Moulay Slissen",
				"name_ar": "مولاي سليسن"
			},
			{
				"id": 279,
				"wilaya_id": 22,
				"code": "279",
				"name": "Tessala",
				"name_ar": "تسالة"
			},
			{
				"id": 280,
				"wilaya_id": 22,
				"code": "280",
				"name": "Ras El Ma",
				"name_ar": "راس الماء"
			},
			{
				"id": 281,
				"wilaya_id": 23,
				"code": "281",
				"name": "Annaba",
				"name_ar": "عنابة"
			},
			{
				"id": 282,
				"wilaya_id": 23,
				"code": "282",
				"name": "El Hadjar",
				"name_ar": "الحجار"
			},
			{
				"id": 283,
				"wilaya_id": 23,
				"code": "283",
				"name": "Ain El Berda",
				"name_ar": "عين الباردة"
			},
			{
				"id": 284,
				"wilaya_id": 23,
				"code": "284",
				"name": "Berrahal",
				"name_ar": "برحال"
			},
			{
				"id": 285,
				"wilaya_id": 23,
				"code": "285",
				"name": "El Bouni",
				"name_ar": "البوني"
			},
			{
				"id": 286,
				"wilaya_id": 23,
				"code": "286",
				"name": "Chetaibi",
				"name_ar": "شطايبي"
			},
			{
				"id": 287,
				"wilaya_id": 24,
				"code": "287",
				"name": "Guelma",
				"name_ar": "قالمة"
			},
			{
				"id": 288,
				"wilaya_id": 24,
				"code": "288",
				"name": "Oued Zenati",
				"name_ar": "وادي الزناتي"
			},
			{
				"id": 289,
				"wilaya_id": 24,
				"code": "289",
				"name": "Bouchegouf",
				"name_ar": "بوشقوف"
			},
			{
				"id": 290,
				"wilaya_id": 24,
				"code": "290",
				"name": "Guelaat Bousbaa",
				"name_ar": "قلعة بوصبع"
			},
			{
				"id": 291,
				"wilaya_id": 24,
				"code": "291",
				"name": "Hammam Debagh",
				"name_ar": "حمام دباغ"
			},
			{
				"id": 292,
				"wilaya_id": 24,
				"code": "292",
				"name": "Heliopolis",
				"name_ar": "هيليوبوليس"
			},
			{
				"id": 293,
				"wilaya_id": 24,
				"code": "293",
				"name": "Hammam N'bails",
				"name_ar": "حمام النبايل"
			},
			{
				"id": 294,
				"wilaya_id": 24,
				"code": "294",
				"name": "Ain Makhlouf",
				"name_ar": "عين مخلوف"
			},
			{
				"id": 295,
				"wilaya_id": 24,
				"code": "295",
				"name": "Ain Hessainia",
				"name_ar": "عين حساينية"
			},
			{
				"id": 296,
				"wilaya_id": 24,
				"code": "296",
				"name": "Khezaras",
				"name_ar": "خزارة"
			},
			{
				"id": 297,
				"wilaya_id": 25,
				"code": "297",
				"name": "Constantine",
				"name_ar": "قسنطينة"
			},
			{
				"id": 298,
				"wilaya_id": 25,
				"code": "298",
				"name": "El Khroub",
				"name_ar": "الخروب"
			},
			{
				"id": 299,
				"wilaya_id": 25,
				"code": "299",
				"name": "Hamma Bouziane",
				"name_ar": "حامة بوزيان"
			},
			{
				"id": 300,
				"wilaya_id": 25,
				"code": "300",
				"name": "Zighoud Youcef",
				"name_ar": "زيغود يوسف"
			},
			{
				"id": 301,
				"wilaya_id": 25,
				"code": "301",
				"name": "Ain Abid",
				"name_ar": "عين عبيد"
			},
			{
				"id": 302,
				"wilaya_id": 25,
				"code": "302",
				"name": "Ibn Ziad",
				"name_ar": "ابن زياد"
			},
			{
				"id": 303,
				"wilaya_id": 26,
				"code": "303",
				"name": "Medea",
				"name_ar": "المدية"
			},
			{
				"id": 304,
				"wilaya_id": 26,
				"code": "304",
				"name": "Beni Slimane",
				"name_ar": "بني سليمان"
			},
			{
				"id": 305,
				"wilaya_id": 26,
				"code": "305",
				"name": "Berrouaghia",
				"name_ar": "البرواقية"
			},
			{
				"id": 306,
				"wilaya_id": 26,
				"code": "306",
				"name": "Ksar El Boukhari",
				"name_ar": "قصر البخاري"
			},
			{
				"id": 307,
				"wilaya_id": 26,
				"code": "307",
				"name": "Tablat",
				"name_ar": "تابلاط"
			},
			{
				"id": 308,
				"wilaya_id": 26,
				"code": "308",
				"name": "Ain Boucif",
				"name_ar": "عين بوسيف"
			},
			{
				"id": 309,
				"wilaya_id": 26,
				"code": "309",
				"name": "Chellalat El Adhaoura",
				"name_ar": "شلالة العذاورة"
			},
			{
				"id": 310,
				"wilaya_id": 26,
				"code": "310",
				"name": "El Omaria",
				"name_ar": "العمارية"
			},
			{
				"id": 311,
				"wilaya_id": 26,
				"code": "311",
				"name": "Ouzera",
				"name_ar": "وزرة"
			},
			{
				"id": 312,
				"wilaya_id": 26,
				"code": "312",
				"name": "Ouled Antar",
				"name_ar": "أولاد عنتر"
			},
			{
				"id": 313,
				"wilaya_id": 26,
				"code": "313",
				"name": "Sidi Naamane",
				"name_ar": "سيدي نعمان"
			},
			{
				"id": 314,
				"wilaya_id": 26,
				"code": "314",
				"name": "Aziz",
				"name_ar": "عزيز"
			},
			{
				"id": 315,
				"wilaya_id": 26,
				"code": "315",
				"name": "Souaghi",
				"name_ar": "السواقي"
			},
			{
				"id": 316,
				"wilaya_id": 26,
				"code": "316",
				"name": "El Azizia",
				"name_ar": "العزيزية"
			},
			{
				"id": 317,
				"wilaya_id": 26,
				"code": "317",
				"name": "Seghouane",
				"name_ar": "سغوان"
			},
			{
				"id": 318,
				"wilaya_id": 26,
				"code": "318",
				"name": "Chahbounia",
				"name_ar": "الشهبونية"
			},
			{
				"id": 319,
				"wilaya_id": 26,
				"code": "319",
				"name": "Ouamri",
				"name_ar": "عوامري"
			},
			{
				"id": 320,
				"wilaya_id": 26,
				"code": "320",
				"name": "Guelb El Kebir",
				"name_ar": "القلب الكبير"
			},
			{
				"id": 321,
				"wilaya_id": 26,
				"code": "321",
				"name": "Si Mahdjoub",
				"name_ar": "سي المحجوب"
			},
			{
				"id": 322,
				"wilaya_id": 27,
				"code": "322",
				"name": "Mostaganem",
				"name_ar": "مستغانم"
			},
			{
				"id": 323,
				"wilaya_id": 27,
				"code": "323",
				"name": "Ain Tedeles",
				"name_ar": "عين تادلس"
			},
			{
				"id": 324,
				"wilaya_id": 27,
				"code": "324",
				"name": "Bouguirat",
				"name_ar": "بوقيراط"
			},
			{
				"id": 325,
				"wilaya_id": 27,
				"code": "325",
				"name": "Hassi Mameche",
				"name_ar": "حاسي ماماش"
			},
			{
				"id": 326,
				"wilaya_id": 27,
				"code": "326",
				"name": "Achaacha",
				"name_ar": "عشعاشة"
			},
			{
				"id": 327,
				"wilaya_id": 27,
				"code": "327",
				"name": "Sidi Lakhdar",
				"name_ar": "سيدي لخضر"
			},
			{
				"id": 328,
				"wilaya_id": 27,
				"code": "328",
				"name": "Ain Nouicy",
				"name_ar": "عين نويسي"
			},
			{
				"id": 329,
				"wilaya_id": 27,
				"code": "329",
				"name": "Mesra",
				"name_ar": "ماسرة"
			},
			{
				"id": 330,
				"wilaya_id": 27,
				"code": "330",
				"name": "Kheir Eddine",
				"name_ar": "خير الدين"
			},
			{
				"id": 331,
				"wilaya_id": 27,
				"code": "331",
				"name": "Sidi Ali",
				"name_ar": "سيدي علي"
			},
			{
				"id": 332,
				"wilaya_id": 28,
				"code": "332",
				"name": "M'sila",
				"name_ar": "المسيلة"
			},
			{
				"id": 333,
				"wilaya_id": 28,
				"code": "333",
				"name": "Bousaada",
				"name_ar": "بوسعادة"
			},
			{
				"id": 334,
				"wilaya_id": 28,
				"code": "334",
				"name": "Sidi Aissa",
				"name_ar": "سيدي عيسى"
			},
			{
				"id": 335,
				"wilaya_id": 28,
				"code": "335",
				"name": "Ain El Hadjel",
				"name_ar": "عين الحجل"
			},
			{
				"id": 336,
				"wilaya_id": 28,
				"code": "336",
				"name": "Ain El Melh",
				"name_ar": "عين الملح"
			},
			{
				"id": 337,
				"wilaya_id": 28,
				"code": "337",
				"name": "Hammam Dalaa",
				"name_ar": "حمام الضلعة"
			},
			{
				"id": 338,
				"wilaya_id": 28,
				"code": "338",
				"name": "Magra",
				"name_ar": "مقرة"
			},
			{
				"id": 339,
				"wilaya_id": 28,
				"code": "339",
				"name": "Ben Srour",
				"name_ar": "بن سرور"
			},
			{
				"id": 340,
				"wilaya_id": 28,
				"code": "340",
				"name": "Ouled Derradj",
				"name_ar": "أولاد دراج"
			},
			{
				"id": 341,
				"wilaya_id": 28,
				"code": "341",
				"name": "Chellal",
				"name_ar": "شلال"
			},
			{
				"id": 342,
				"wilaya_id": 28,
				"code": "342",
				"name": "Medjedel",
				"name_ar": "امجدل"
			},
			{
				"id": 343,
				"wilaya_id": 28,
				"code": "343",
				"name": "Djebel Messaad",
				"name_ar": "جبل مساعد"
			},
			{
				"id": 344,
				"wilaya_id": 28,
				"code": "344",
				"name": "Ouled Sidi Brahim",
				"name_ar": "أولاد سيدي ابراهيم"
			},
			{
				"id": 345,
				"wilaya_id": 28,
				"code": "345",
				"name": "Khoubana",
				"name_ar": "خبانة"
			},
			{
				"id": 346,
				"wilaya_id": 28,
				"code": "346",
				"name": "Sidi Ameur",
				"name_ar": "سيدي عامر"
			},
			{
				"id": 347,
				"wilaya_id": 29,
				"code": "347",
				"name": "Mascara",
				"name_ar": "معسكر"
			},
			{
				"id": 348,
				"wilaya_id": 29,
				"code": "348",
				"name": "Sig",
				"name_ar": "سيق"
			},
			{
				"id": 349,
				"wilaya_id": 29,
				"code": "349",
				"name": "Mohammadia",
				"name_ar": "المحمدية"
			},
			{
				"id": 350,
				"wilaya_id": 29,
				"code": "350",
				"name": "Tighennif",
				"name_ar": "تيغنيف"
			},
			{
				"id": 351,
				"wilaya_id": 29,
				"code": "351",
				"name": "Bouhanifia",
				"name_ar": "بوحنيفية"
			},
			{
				"id": 352,
				"wilaya_id": 29,
				"code": "352",
				"name": "Ghriss",
				"name_ar": "غريس"
			},
			{
				"id": 353,
				"wilaya_id": 29,
				"code": "353",
				"name": "Ain Fekan",
				"name_ar": "عين فكان"
			},
			{
				"id": 354,
				"wilaya_id": 29,
				"code": "354",
				"name": "El Bordj",
				"name_ar": "البرج"
			},
			{
				"id": 355,
				"wilaya_id": 29,
				"code": "355",
				"name": "Hachem",
				"name_ar": "الحشم"
			},
			{
				"id": 356,
				"wilaya_id": 29,
				"code": "356",
				"name": "Oued El Abtal",
				"name_ar": "وادي الأبطال"
			},
			{
				"id": 357,
				"wilaya_id": 29,
				"code": "357",
				"name": "Oued Taria",
				"name_ar": "وادي التاغية"
			},
			{
				"id": 358,
				"wilaya_id": 29,
				"code": "358",
				"name": "Zahana",
				"name_ar": "زهانة"
			},
			{
				"id": 359,
				"wilaya_id": 29,
				"code": "359",
				"name": "Aouf",
				"name_ar": "عوف"
			},
			{
				"id": 360,
				"wilaya_id": 29,
				"code": "360",
				"name": "Tizi",
				"name_ar": "تيزي"
			},
			{
				"id": 361,
				"wilaya_id": 29,
				"code": "361",
				"name": "Oggaz",
				"name_ar": "عقاز"
			},
			{
				"id": 362,
				"wilaya_id": 29,
				"code": "362",
				"name": "Ain Fares",
				"name_ar": "عين فارس"
			},
			{
				"id": 363,
				"wilaya_id": 30,
				"code": "363",
				"name": "Ouargla",
				"name_ar": "ورقلة"
			},
			{
				"id": 364,
				"wilaya_id": 30,
				"code": "364",
				"name": "Hassi Messaoud",
				"name_ar": "حاسي مسعود"
			},
			{
				"id": 365,
				"wilaya_id": 30,
				"code": "365",
				"name": "El Borma",
				"name_ar": "البرمة"
			},
			{
				"id": 366,
				"wilaya_id": 30,
				"code": "366",
				"name": "N'goussa",
				"name_ar": "انقوسة"
			},
			{
				"id": 367,
				"wilaya_id": 30,
				"code": "367",
				"name": "Sidi Khouiled",
				"name_ar": "سيدي خويلد"
			},
			{
				"id": 368,
				"wilaya_id": 31,
				"code": "368",
				"name": "Oran",
				"name_ar": "وهران"
			},
			{
				"id": 369,
				"wilaya_id": 31,
				"code": "369",
				"name": "Bir El Djir",
				"name_ar": "بئر الجير"
			},
			{
				"id": 370,
				"wilaya_id": 31,
				"code": "370",
				"name": "Arzew",
				"name_ar": "أرزيو"
			},
			{
				"id": 371,
				"wilaya_id": 31,
				"code": "371",
				"name": "Es Senia",
				"name_ar": "السانية"
			},
			{
				"id": 372,
				"wilaya_id": 31,
				"code": "372",
				"name": "Ain Turk",
				"name_ar": "عين الترك"
			},
			{
				"id": 373,
				"wilaya_id": 31,
				"code": "373",
				"name": "Bethioua",
				"name_ar": "بطيوة"
			},
			{
				"id": 374,
				"wilaya_id": 31,
				"code": "374",
				"name": "Boutlelis",
				"name_ar": "بوتليليس"
			},
			{
				"id": 375,
				"wilaya_id": 31,
				"code": "375",
				"name": "Gdyel",
				"name_ar": "قديل"
			},
			{
				"id": 376,
				"wilaya_id": 31,
				"code": "376",
				"name": "Oued Tlelat",
				"name_ar": "وادي تليلات"
			},
			{
				"id": 377,
				"wilaya_id": 32,
				"code": "377",
				"name": "El Bayadh",
				"name_ar": "البيض"
			},
			{
				"id": 378,
				"wilaya_id": 32,
				"code": "378",
				"name": "Bougtoub",
				"name_ar": "بوقطب"
			},
			{
				"id": 379,
				"wilaya_id": 32,
				"code": "379",
				"name": "Brezina",
				"name_ar": "بريزينة"
			},
			{
				"id": 380,
				"wilaya_id": 32,
				"code": "380",
				"name": "Labiodh Sidi Cheikh",
				"name_ar": "الأبيض سيدي الشيخ"
			},
			{
				"id": 381,
				"wilaya_id": 32,
				"code": "381",
				"name": "Boualem",
				"name_ar": "بوعلام"
			},
			{
				"id": 382,
				"wilaya_id": 32,
				"code": "382",
				"name": "Rogassa",
				"name_ar": "رقاصة"
			},
			{
				"id": 383,
				"wilaya_id": 32,
				"code": "383",
				"name": "Boussemghoun",
				"name_ar": "بوسمغون"
			},
			{
				"id": 384,
				"wilaya_id": 32,
				"code": "384",
				"name": "Chellala",
				"name_ar": "شلالة"
			},
			{
				"id": 385,
				"wilaya_id": 33,
				"code": "385",
				"name": "Illizi",
				"name_ar": "إيليزي"
			},
			{
				"id": 386,
				"wilaya_id": 33,
				"code": "386",
				"name": "In Amenas",
				"name_ar": "إن أمناس"
			},
			{
				"id": 387,
				"wilaya_id": 34,
				"code": "387",
				"name": "Bordj Bou Arreridj",
				"name_ar": "برج بوعريريج"
			},
			{
				"id": 388,
				"wilaya_id": 34,
				"code": "388",
				"name": "Ras El Oued",
				"name_ar": "رأس الوادي"
			},
			{
				"id": 389,
				"wilaya_id": 34,
				"code": "389",
				"name": "Bordj Ghedir",
				"name_ar": "برج الغدير"
			},
			{
				"id": 390,
				"wilaya_id": 34,
				"code": "390",
				"name": "Bordj Zemmoura",
				"name_ar": "برج زمورة"
			},
			{
				"id": 391,
				"wilaya_id": 34,
				"code": "391",
				"name": "Medjana",
				"name_ar": "مجانة"
			},
			{
				"id": 392,
				"wilaya_id": 34,
				"code": "392",
				"name": "Mansourah",
				"name_ar": "المنصورة"
			},
			{
				"id": 393,
				"wilaya_id": 34,
				"code": "393",
				"name": "Ain Taghrout",
				"name_ar": "عين تاغروت"
			},
			{
				"id": 394,
				"wilaya_id": 34,
				"code": "394",
				"name": "Bir Kasdali",
				"name_ar": "بئر قاصد علي"
			},
			{
				"id": 395,
				"wilaya_id": 34,
				"code": "395",
				"name": "Djaafra",
				"name_ar": "جعافرة"
			},
			{
				"id": 396,
				"wilaya_id": 34,
				"code": "396",
				"name": "El Hamadia",
				"name_ar": "الحمادية"
			},
			{
				"id": 397,
				"wilaya_id": 35,
				"code": "397",
				"name": "Boumerdes",
				"name_ar": "بومرداس"
			},
			{
				"id": 398,
				"wilaya_id": 35,
				"code": "398",
				"name": "Bordj Menaiel",
				"name_ar": "برج منايل"
			},
			{
				"id": 399,
				"wilaya_id": 35,
				"code": "399",
				"name": "Boudouaou",
				"name_ar": "بودواو"
			},
			{
				"id": 400,
				"wilaya_id": 35,
				"code": "400",
				"name": "Dellys",
				"name_ar": "دلس"
			},
			{
				"id": 401,
				"wilaya_id": 35,
				"code": "401",
				"name": "Thenia",
				"name_ar": "الثنية"
			},
			{
				"id": 402,
				"wilaya_id": 35,
				"code": "402",
				"name": "Isser",
				"name_ar": "يسر"
			},
			{
				"id": 403,
				"wilaya_id": 35,
				"code": "403",
				"name": "Khemis El Khechna",
				"name_ar": "خميس الخشنة"
			},
			{
				"id": 404,
				"wilaya_id": 35,
				"code": "404",
				"name": "Baghlia",
				"name_ar": "بغلية"
			},
			{
				"id": 405,
				"wilaya_id": 35,
				"code": "405",
				"name": "Naciria",
				"name_ar": "الناصرية"
			},
			{
				"id": 406,
				"wilaya_id": 36,
				"code": "406",
				"name": "El Tarf",
				"name_ar": "الطارف"
			},
			{
				"id": 407,
				"wilaya_id": 36,
				"code": "407",
				"name": "Drean",
				"name_ar": "الذرعان"
			},
			{
				"id": 408,
				"wilaya_id": 36,
				"code": "408",
				"name": "El Kala",
				"name_ar": "القالة"
			},
			{
				"id": 409,
				"wilaya_id": 36,
				"code": "409",
				"name": "Ben M'hidi",
				"name_ar": "بن مهيدي"
			},
			{
				"id": 410,
				"wilaya_id": 36,
				"code": "410",
				"name": "Bouhadjar",
				"name_ar": "بوحجار"
			},
			{
				"id": 411,
				"wilaya_id": 36,
				"code": "411",
				"name": "Bouteldja",
				"name_ar": "بوثلجة"
			},
			{
				"id": 412,
				"wilaya_id": 36,
				"code": "412",
				"name": "Besbes",
				"name_ar": "البسباس"
			},
			{
				"id": 413,
				"wilaya_id": 37,
				"code": "413",
				"name": "Tindouf",
				"name_ar": "تندوف"
			},
			{
				"id": 414,
				"wilaya_id": 38,
				"code": "414",
				"name": "Tissemsilt",
				"name_ar": "تيسمسيلت"
			},
			{
				"id": 415,
				"wilaya_id": 38,
				"code": "415",
				"name": "Bordj Bounaama",
				"name_ar": "برج بونعامة"
			},
			{
				"id": 416,
				"wilaya_id": 38,
				"code": "416",
				"name": "Lardjem",
				"name_ar": "لرجام"
			},
			{
				"id": 417,
				"wilaya_id": 38,
				"code": "417",
				"name": "Theniet El Had",
				"name_ar": "ثنية الاحد"
			},
			{
				"id": 418,
				"wilaya_id": 38,
				"code": "418",
				"name": "Lazharia",
				"name_ar": "الأزهرية"
			},
			{
				"id": 419,
				"wilaya_id": 38,
				"code": "419",
				"name": "Khemisti",
				"name_ar": "خميستي"
			},
			{
				"id": 420,
				"wilaya_id": 38,
				"code": "420",
				"name": "Ammari",
				"name_ar": "عماري"
			},
			{
				"id": 421,
				"wilaya_id": 38,
				"code": "421",
				"name": "Bordj Emir Abdelkader",
				"name_ar": "برج الأمير عبد القادر"
			},
			{
				"id": 422,
				"wilaya_id": 39,
				"code": "422",
				"name": "El Oued",
				"name_ar": "الوادي"
			},
			{
				"id": 423,
				"wilaya_id": 39,
				"code": "423",
				"name": "Guemar",
				"name_ar": "قمار"
			},
			{
				"id": 424,
				"wilaya_id": 39,
				"code": "424",
				"name": "Debila",
				"name_ar": "الدبيلة"
			},
			{
				"id": 425,
				"wilaya_id": 39,
				"code": "425",
				"name": "Bayadha",
				"name_ar": "البياضة"
			},
			{
				"id": 426,
				"wilaya_id": 39,
				"code": "426",
				"name": "Hassi Khalifa",
				"name_ar": "حاسي خليفة"
			},
			{
				"id": 427,
				"wilaya_id": 39,
				"code": "427",
				"name": "Magrane",
				"name_ar": "المقرن"
			},
			{
				"id": 428,
				"wilaya_id": 39,
				"code": "428",
				"name": "Reguiba",
				"name_ar": "الرقيبة"
			},
			{
				"id": 429,
				"wilaya_id": 39,
				"code": "429",
				"name": "Robbah",
				"name_ar": "الرباح"
			},
			{
				"id": 430,
				"wilaya_id": 39,
				"code": "430",
				"name": "Taleb Larbi",
				"name_ar": "الطالب العربي"
			},
			{
				"id": 431,
				"wilaya_id": 39,
				"code": "431",
				"name": "Mih Ouensa",
				"name_ar": "اميه وانسة"
			},
			{
				"id": 432,
				"wilaya_id": 40,
				"code": "432",
				"name": "Khenchela",
				"name_ar": "خنشلة"
			},
			{
				"id": 433,
				"wilaya_id": 40,
				"code": "433",
				"name": "Kais",
				"name_ar": "قايس"
			},
			{
				"id": 434,
				"wilaya_id": 40,
				"code": "434",
				"name": "Babar",
				"name_ar": "بابار"
			},
			{
				"id": 435,
				"wilaya_id": 40,
				"code": "435",
				"name": "Bouhmama",
				"name_ar": "بوحمامة"
			},
			{
				"id": 436,
				"wilaya_id": 40,
				"code": "436",
				"name": "Chechar",
				"name_ar": "ششار"
			},
			{
				"id": 437,
				"wilaya_id": 40,
				"code": "437",
				"name": "Ouled Rechache",
				"name_ar": "أولاد رشاش"
			},
			{
				"id": 438,
				"wilaya_id": 40,
				"code": "438",
				"name": "El Hamma",
				"name_ar": "الحامة"
			},
			{
				"id": 439,
				"wilaya_id": 40,
				"code": "439",
				"name": "Ain Touila",
				"name_ar": "عين الطويلة"
			},
			{
				"id": 440,
				"wilaya_id": 41,
				"code": "440",
				"name": "Souk Ahras",
				"name_ar": "سوق أهراس"
			},
			{
				"id": 441,
				"wilaya_id": 41,
				"code": "441",
				"name": "M'daourouche",
				"name_ar": "مداوروش"
			},
			{
				"id": 442,
				"wilaya_id": 41,
				"code": "442",
				"name": "Merahna",
				"name_ar": "المراهنة"
			},
			{
				"id": 443,
				"wilaya_id": 41,
				"code": "443",
				"name": "Ouled Driss",
				"name_ar": "أولاد إدريس"
			},
			{
				"id": 444,
				"wilaya_id": 41,
				"code": "444",
				"name": "Sedrata",
				"name_ar": "سدراتة"
			},
			{
				"id": 445,
				"wilaya_id": 41,
				"code": "445",
				"name": "Taoura",
				"name_ar": "تاورة"
			},
			{
				"id": 446,
				"wilaya_id": 41,
				"code": "446",
				"name": "Mechroha",
				"name_ar": "المشروحة"
			},
			{
				"id": 447,
				"wilaya_id": 41,
				"code": "447",
				"name": "Bir Bouhouche",
				"name_ar": "بئر بوحوش"
			},
			{
				"id": 448,
				"wilaya_id": 41,
				"code": "448",
				"name": "Haddada",
				"name_ar": "الحدادة"
			},
			{
				"id": 449,
				"wilaya_id": 41,
				"code": "449",
				"name": "Oum El Adhaim",
				"name_ar": "أم العظايم"
			},
			{
				"id": 450,
				"wilaya_id": 42,
				"code": "450",
				"name": "Tipaza",
				"name_ar": "تيبازة"
			},
			{
				"id": 451,
				"wilaya_id": 42,
				"code": "451",
				"name": "Hadjout",
				"name_ar": "حجوط"
			},
			{
				"id": 452,
				"wilaya_id": 42,
				"code": "452",
				"name": "Cherchell",
				"name_ar": "شرشال"
			},
			{
				"id": 453,
				"wilaya_id": 42,
				"code": "453",
				"name": "Kolea",
				"name_ar": "القليعة"
			},
			{
				"id": 454,
				"wilaya_id": 42,
				"code": "454",
				"name": "Bou Ismail",
				"name_ar": "بواسماعيل"
			},
			{
				"id": 455,
				"wilaya_id": 42,
				"code": "455",
				"name": "Ahmar El Ain",
				"name_ar": "أحمر العين"
			},
			{
				"id": 456,
				"wilaya_id": 42,
				"code": "456",
				"name": "Fouka",
				"name_ar": "فوكة"
			},
			{
				"id": 457,
				"wilaya_id": 42,
				"code": "457",
				"name": "Gouraya",
				"name_ar": "قوراية"
			},
			{
				"id": 458,
				"wilaya_id": 42,
				"code": "458",
				"name": "Damous",
				"name_ar": "الداموس"
			},
			{
				"id": 459,
				"wilaya_id": 42,
				"code": "459",
				"name": "Sidi Amar",
				"name_ar": "سيدي أعمر"
			},
			{
				"id": 460,
				"wilaya_id": 43,
				"code": "460",
				"name": "Mila",
				"name_ar": "ميلة"
			},
			{
				"id": 461,
				"wilaya_id": 43,
				"code": "461",
				"name": "Chelghoum Laid",
				"name_ar": "شلغوم العيد"
			},
			{
				"id": 462,
				"wilaya_id": 43,
				"code": "462",
				"name": "Ferdjioua",
				"name_ar": "فرجيوة"
			},
			{
				"id": 463,
				"wilaya_id": 43,
				"code": "463",
				"name": "Grarem Gouga",
				"name_ar": "القرارم قوقة"
			},
			{
				"id": 464,
				"wilaya_id": 43,
				"code": "464",
				"name": "Oued Endja",
				"name_ar": "وادي النجاء"
			},
			{
				"id": 465,
				"wilaya_id": 43,
				"code": "465",
				"name": "Tadjenanet",
				"name_ar": "تاجنانت"
			},
			{
				"id": 466,
				"wilaya_id": 43,
				"code": "466",
				"name": "Teleghma",
				"name_ar": "التلاغمة"
			},
			{
				"id": 467,
				"wilaya_id": 43,
				"code": "467",
				"name": "Rouached",
				"name_ar": "الرواشد"
			},
			{
				"id": 468,
				"wilaya_id": 43,
				"code": "468",
				"name": "Sidi Merouane",
				"name_ar": "سيدي مروان"
			},
			{
				"id": 469,
				"wilaya_id": 43,
				"code": "469",
				"name": "Ain Beida Harriche",
				"name_ar": "عين البيضاء أحريش"
			},
			{
				"id": 470,
				"wilaya_id": 43,
				"code": "470",
				"name": "Terrai Bainen",
				"name_ar": "ترعي باينان"
			},
			{
				"id": 471,
				"wilaya_id": 43,
				"code": "471",
				"name": "Bouhatem",
				"name_ar": "بوحاتم"
			},
			{
				"id": 472,
				"wilaya_id": 43,
				"code": "472",
				"name": "Tassadane Haddada",
				"name_ar": "تسدان حدادة"
			},
			{
				"id": 473,
				"wilaya_id": 44,
				"code": "473",
				"name": "Ain Defla",
				"name_ar": "عين الدفلى"
			},
			{
				"id": 474,
				"wilaya_id": 44,
				"code": "474",
				"name": "Khemis",
				"name_ar": "خميس"
			},
			{
				"id": 475,
				"wilaya_id": 44,
				"code": "475",
				"name": "El Attaf",
				"name_ar": "العطاف"
			},
			{
				"id": 476,
				"wilaya_id": 44,
				"code": "476",
				"name": "Miliana",
				"name_ar": "مليانة"
			},
			{
				"id": 477,
				"wilaya_id": 44,
				"code": "477",
				"name": "Boumedfaa",
				"name_ar": "بومدفع"
			},
			{
				"id": 478,
				"wilaya_id": 44,
				"code": "478",
				"name": "Djendel",
				"name_ar": "جندل"
			},
			{
				"id": 479,
				"wilaya_id": 44,
				"code": "479",
				"name": "El Abadia",
				"name_ar": "العبادية"
			},
			{
				"id": 480,
				"wilaya_id": 44,
				"code": "480",
				"name": "El Amra",
				"name_ar": "العامرة"
			},
			{
				"id": 481,
				"wilaya_id": 44,
				"code": "481",
				"name": "Djelida",
				"name_ar": "جليدة"
			},
			{
				"id": 482,
				"wilaya_id": 44,
				"code": "482",
				"name": "Rouina",
				"name_ar": "الروينة"
			},
			{
				"id": 483,
				"wilaya_id": 44,
				"code": "483",
				"name": "Ain Lechiakh",
				"name_ar": "عين الاشياخ"
			},
			{
				"id": 484,
				"wilaya_id": 44,
				"code": "484",
				"name": "Hammam Righa",
				"name_ar": "حمام ريغة"
			},
			{
				"id": 485,
				"wilaya_id": 44,
				"code": "485",
				"name": "Bordj El Emir Khaled",
				"name_ar": "برج الأمير خالد"
			},
			{
				"id": 486,
				"wilaya_id": 44,
				"code": "486",
				"name": "Bathia",
				"name_ar": "بطحية"
			},
			{
				"id": 487,
				"wilaya_id": 45,
				"code": "487",
				"name": "Naama",
				"name_ar": "النعامة"
			},
			{
				"id": 488,
				"wilaya_id": 45,
				"code": "488",
				"name": "Ain Sefra",
				"name_ar": "عين الصفراء"
			},
			{
				"id": 489,
				"wilaya_id": 45,
				"code": "489",
				"name": "Mecheria",
				"name_ar": "المشرية"
			},
			{
				"id": 490,
				"wilaya_id": 45,
				"code": "490",
				"name": "Mekmen Ben Amar",
				"name_ar": "مكمن بن عمار"
			},
			{
				"id": 491,
				"wilaya_id": 45,
				"code": "491",
				"name": "Asla",
				"name_ar": "عسلة"
			},
			{
				"id": 492,
				"wilaya_id": 45,
				"code": "492",
				"name": "Moghrar",
				"name_ar": "مغرار"
			},
			{
				"id": 493,
				"wilaya_id": 45,
				"code": "493",
				"name": "Sfissifa",
				"name_ar": "سفيسيفة"
			},
			{
				"id": 494,
				"wilaya_id": 46,
				"code": "494",
				"name": "Ain Temouchent",
				"name_ar": "عين تموشنت"
			},
			{
				"id": 495,
				"wilaya_id": 46,
				"code": "495",
				"name": "Beni Saf",
				"name_ar": "بني صاف"
			},
			{
				"id": 496,
				"wilaya_id": 46,
				"code": "496",
				"name": "Hammam Bou Hadjar",
				"name_ar": "حمام بوحجر"
			},
			{
				"id": 497,
				"wilaya_id": 46,
				"code": "497",
				"name": "El Amria",
				"name_ar": "العامرية"
			},
			{
				"id": 498,
				"wilaya_id": 46,
				"code": "498",
				"name": "Ain Kihel",
				"name_ar": "عين الكيحل"
			},
			{
				"id": 499,
				"wilaya_id": 46,
				"code": "499",
				"name": "Ain Larbaa",
				"name_ar": "عين الأربعاء"
			},
			{
				"id": 500,
				"wilaya_id": 46,
				"code": "500",
				"name": "El Maleh",
				"name_ar": "المالح"
			},
			{
				"id": 501,
				"wilaya_id": 46,
				"code": "501",
				"name": "Oulhassa Gheraba",
				"name_ar": "ولهاصة الغرابة"
			},
			{
				"id": 502,
				"wilaya_id": 47,
				"code": "502",
				"name": "Ghardaia",
				"name_ar": "غرداية"
			},
			{
				"id": 503,
				"wilaya_id": 47,
				"code": "503",
				"name": "Metlili",
				"name_ar": "متليلي"
			},
			{
				"id": 504,
				"wilaya_id": 47,
				"code": "504",
				"name": "Berriane",
				"name_ar": "بريان"
			},
			{
				"id": 505,
				"wilaya_id": 47,
				"code": "505",
				"name": "El Guerrara",
				"name_ar": "القرارة"
			},
			{
				"id": 506,
				"wilaya_id": 47,
				"code": "506",
				"name": "Bounoura",
				"name_ar": "بونورة"
			},
			{
				"id": 507,
				"wilaya_id": 47,
				"code": "507",
				"name": "Zelfana",
				"name_ar": "زلفانة"
			},
			{
				"id": 508,
				"wilaya_id": 47,
				"code": "508",
				"name": "Dhayet Ben Dhahoua",
				"name_ar": "ضاية بن ضحوة"
			},
			{
				"id": 509,
				"wilaya_id": 47,
				"code": "509",
				"name": "Mansourah",
				"name_ar": "المنصورة"
			},
			{
				"id": 510,
				"wilaya_id": 48,
				"code": "510",
				"name": "Relizane",
				"name_ar": "غليزان"
			},
			{
				"id": 511,
				"wilaya_id": 48,
				"code": "511",
				"name": "Oued Rhiou",
				"name_ar": "وادي رهيو"
			},
			{
				"id": 512,
				"wilaya_id": 48,
				"code": "512",
				"name": "Mazouna",
				"name_ar": "مازونة"
			},
			{
				"id": 513,
				"wilaya_id": 48,
				"code": "513",
				"name": "Sidi M'hamed Ben Ali",
				"name_ar": "سيدي أمحمد بن علي"
			},
			{
				"id": 514,
				"wilaya_id": 48,
				"code": "514",
				"name": "Ammi Moussa",
				"name_ar": "عمي موسى"
			},
			{
				"id": 515,
				"wilaya_id": 48,
				"code": "515",
				"name": "Djidiouia",
				"name_ar": "جديوية"
			},
			{
				"id": 516,
				"wilaya_id": 48,
				"code": "516",
				"name": "Yellel",
				"name_ar": "يلل"
			},
			{
				"id": 517,
				"wilaya_id": 48,
				"code": "517",
				"name": "Zemmoura",
				"name_ar": "زمورة"
			},
			{
				"id": 518,
				"wilaya_id": 48,
				"code": "518",
				"name": "El Matmar",
				"name_ar": "المطمر"
			},
			{
				"id": 519,
				"wilaya_id": 48,
				"code": "519",
				"name": "Mendes",
				"name_ar": "منداس"
			},
			{
				"id": 520,
				"wilaya_id": 48,
				"code": "520",
				"name": "Ain Tarek",
				"name_ar": "عين طارق"
			},
			{
				"id": 521,
				"wilaya_id": 48,
				"code": "521",
				"name": "El H'madna",
				"name_ar": "الحمادنة"
			},
			{
				"id": 522,
				"wilaya_id": 48,
				"code": "522",
				"name": "Ramka",
				"name_ar": "الرمكة"
			},
			{
				"id": 523,
				"wilaya_id": 49,
				"code": "523",
				"name": "Timimoun",
				"name_ar": "تيميمون"
			},
			{
				"id": 524,
				"wilaya_id": 49,
				"code": "524",
				"name": "Aougrout",
				"name_ar": "أوقروت"
			},
			{
				"id": 525,
				"wilaya_id": 49,
				"code": "525",
				"name": "Tinerkouk",
				"name_ar": "تنركوك"
			},
			{
				"id": 526,
				"wilaya_id": 49,
				"code": "526",
				"name": "Charouine",
				"name_ar": "شروين"
			},
			{
				"id": 527,
				"wilaya_id": 50,
				"code": "527",
				"name": "Bordj Badji Mokhtar",
				"name_ar": "برج باجي مختار"
			},
			{
				"id": 528,
				"wilaya_id": 51,
				"code": "528",
				"name": "Ouled Djellal",
				"name_ar": "أولاد جلال"
			},
			{
				"id": 529,
				"wilaya_id": 51,
				"code": "529",
				"name": "Sidi Khaled",
				"name_ar": "سيدي  خالد"
			},
			{
				"id": 530,
				"wilaya_id": 52,
				"code": "530",
				"name": "Beni Abbes",
				"name_ar": "بني عباس"
			},
			{
				"id": 531,
				"wilaya_id": 52,
				"code": "531",
				"name": "El Ouata",
				"name_ar": "الواتة"
			},
			{
				"id": 532,
				"wilaya_id": 52,
				"code": "532",
				"name": "Igli",
				"name_ar": "إقلي"
			},
			{
				"id": 533,
				"wilaya_id": 52,
				"code": "533",
				"name": "Kerzaz",
				"name_ar": "كرزاز"
			},
			{
				"id": 534,
				"wilaya_id": 52,
				"code": "534",
				"name": "Ouled Khodeir",
				"name_ar": "أولاد خضير"
			},
			{
				"id": 535,
				"wilaya_id": 53,
				"code": "535",
				"name": "In Salah",
				"name_ar": "عين صالح"
			},
			{
				"id": 536,
				"wilaya_id": 53,
				"code": "536",
				"name": "In Ghar",
				"name_ar": "إينغر"
			},
			{
				"id": 537,
				"wilaya_id": 54,
				"code": "537",
				"name": "In Guezzam",
				"name_ar": "عين قزام"
			},
			{
				"id": 538,
				"wilaya_id": 54,
				"code": "538",
				"name": "Tin Zouatine",
				"name_ar": "تين زواتين"
			},
			{
				"id": 539,
				"wilaya_id": 55,
				"code": "539",
				"name": "Touggourt",
				"name_ar": "تقرت"
			},
			{
				"id": 540,
				"wilaya_id": 55,
				"code": "540",
				"name": "Temacine",
				"name_ar": "تماسين"
			},
			{
				"id": 541,
				"wilaya_id": 55,
				"code": "541",
				"name": "El-Hadjira",
				"name_ar": "الحجيرة"
			},
			{
				"id": 542,
				"wilaya_id": 55,
				"code": "542",
				"name": "Megarine",
				"name_ar": "المقارين"
			},
			{
				"id": 543,
				"wilaya_id": 55,
				"code": "543",
				"name": "Taibet",
				"name_ar": "الطيبات"
			},
			{
				"id": 544,
				"wilaya_id": 56,
				"code": "544",
				"name": "Djanet",
				"name_ar": "جانت"
			},
			{
				"id": 545,
				"wilaya_id": 57,
				"code": "545",
				"name": "Djamaa",
				"name_ar": "جامعة"
			},
			{
				"id": 546,
				"wilaya_id": 57,
				"code": "546",
				"name": "El Meghaier",
				"name_ar": "المغير"
			},
			{
				"id": 547,
				"wilaya_id": 58,
				"code": "547",
				"name": "El Menia",
				"name_ar": "المنيعة"
			},
			{
				"id": 548,
				"wilaya_id": 58,
				"code": "548",
				"name": "Mansourah",
				"name_ar": "المنصورة"
			}
		]
